<template>
    <div class="deal-share">
        <div class="backend-links">
            <a href="/dealshare">Deal Share</a>
            <a href="/deal-list-manager">Manage Blog/Gift Lists</a>
            <a href="/logout">LOG OUT</a>
        </div>
        <h1>Manage Blog/Gift Lists</h1>
        <div class="deal-share-header">
            <div><input v-model="dealNumber" placeholder="Deal #" class="share-deal-input" v-on:blur="clear()" /></div>
            <div v-if="latestDeals" class="latest-deals">
                <a @click="clear(); dealNumber = deal.DealID; generate();" v-for="deal in latestDeals" :key="deal.DealID">{{deal.DealID}}</a>
                <a @click="getLatestDeals()">REFRESH</a>
            </div>
            <div><textarea v-model="dealText" placeholder="Great Deal!" class="share-deal-input"></textarea></div>
            <div><textarea v-model="dealTitle" placeholder="Deal Title (optional)" class="share-deal-input"></textarea></div>
            <div><button class="button" :disabled="!dealNumber" @click="generate()">Generate</button></div>
            <div><img v-if="dealDetails" :src="dealDetails.ImgUrl" style="max-height: 200px;" /></div>
        </div>
        <div v-show="isBusy">
            <span class="icon"><img src="/Assets/img/spin.svg" /></span> LOADING
        </div>
        <br />
        <TabMenu :tabs="tabs" :initialTab="initialTab">

            <template slot="tab-head-facebook">
                Facebook
            </template>
            <template slot="tab-panel-facebook">
                <div>
                    <div v-if="facebookMessage" class="deal-share-header">
                        <div class="share-message-container">
                            <textarea v-model="facebookMessage" id="facebookMessage" placeholder="" class="share-deal-input share-deal-share-message"></textarea>
                        </div>
                        <a v-show="!copied2" class="promo-copy-code" @click="copyToClipboard('facebookMessage')">COPY</a>
                        <a v-show="copied2" class="promo-copy-code copied">COPIED</a>
                    </div>
                </div>
                <div>
                    <div v-if="facebookMessage2" class="deal-share-header">
                        <div class="share-message-container">
                            <textarea v-model="facebookMessage2" id="facebookMessage2" placeholder="" class="share-deal-input share-deal-share-message"></textarea>
                        </div>
                        <a v-show="!copied3" class="promo-copy-code" @click="copyToClipboard('facebookMessage2')">COPY</a>
                        <a v-show="copied3" class="promo-copy-code copied">COPIED</a>
                    </div>
                </div>
            </template>

            <template slot="tab-head-telegram">
                Telegram
            </template>
            <template slot="tab-panel-telegram">
                <div>
                    <div v-if="dealDetails">
                        <textarea v-model="telegram.message" id="telegramMessage" placeholder="telegram custom message" class="share-deal-input share-deal-share-message"></textarea>
                        <div v-if="!telegram.isPosted"><button class="button" :disabled="telegram.isBusy" @click="postToTelegram()">Post to Telegram</button></div>
                        <div v-if="telegram.isPosted"><button class="button button-success" :disabled="telegram.isPosted">POSTED</button></div>
                    </div>
                </div>
            </template>

            <template slot="tab-head-whatsapp">
                WhatsApp
            </template>
            <template slot="tab-panel-whatsapp">
                <div>
                    <div v-if="shareMessage" class="deal-share-header">
                        <div class="share-message-container">
                            <textarea v-model="shareMessage" id="shareMessage" placeholder="" class="share-deal-input share-deal-share-message"></textarea>
                        </div>
                        <a v-show="!copied" class="promo-copy-code" @click="copyToClipboard('shareMessage')">COPY</a>
                        <a v-show="copied" class="promo-copy-code copied">COPIED</a>
                    </div>
                </div>
            </template>

            <template slot="tab-head-images">
                Story Images
            </template>
            <template slot="tab-panel-images">
                <div>
                    <div v-if="storyMessage" class="deal-share-header">
                        <div class="share-message-container">
                            <textarea v-model="storyMessage" id="storyMessage" placeholder="" class="share-deal-input share-deal-share-message"></textarea>
                        </div>
                        <a v-show="!copied3" class="promo-copy-code" @click="copyToClipboard('storyMessage')">COPY</a>
                        <a v-show="copied3" class="promo-copy-code copied">COPIED</a>
                    </div>
                </div>
                <div v-if="images" class="deal-share-results">
                    <img :src="image" v-for="image in images" :key="image" />
                </div>
            </template>

            <template slot="tab-head-raw">
                RAW
            </template>
            <template slot="tab-panel-raw">
                <div v-if="dealDetails" class="deal-share-results">
                    <textarea v-model="dealDetailsJson" class="share-deal-input share-deal-share-message" style="text-align: left"></textarea>
                </div>
            </template>
        </TabMenu>








    </div>
</template>
<script>
    import settings from '@/settings'
    import api from '@/api'
    import TabMenu from '@/components/TabMenu'

    export default {
        data() {
            return {
                initialTab: 'images',
                latestDeals: null,
                tabs: ['facebook', 'telegram', 'whatsapp', 'images', 'raw'],
                isBusy: false,
                dealNumber: null,
                dealText: 'Great Deal!',
                dealTitle: null,
                images: null,
                results: false,
                dealDetails: null,
                shareMessage: null,
                facebookMessage: null,
                facebookMessage2: null,
                storyMessage: null,
                copied: false,
                copied2: false,
                copied3: false,
                copied4: false,
                telegram: {
                    message: null,
                    isPosted: false,
                    isBusy: false
                }
            }
        },
        methods: {
            getLatestDeals() {
                api.getLatestDeals(5, 1, null).then(response => {
                    this.latestDeals = response.data;
                });
            },
            clear() {
                this.dealText = 'Great Deal!';
                this.dealTitle = null;
            },
            copyToClipboard(textboxName) {
                var copyText = document.getElementById(textboxName);
                copyText.select();
                document.execCommand("copy");

                if (textboxName == 'shareMessage') {
                    this.copied = true;
                    setTimeout(() => {
                        this.copied = false;
                    }, 2000);
                }

                if (textboxName == 'facebookMessage') {
                    this.copied2 = true;
                    setTimeout(() => {
                        this.copied2 = false;
                    }, 2000);
                }

                if (textboxName == 'facebookMessage2') {
                    this.copied3 = true;
                    setTimeout(() => {
                        this.copied3 = false;
                    }, 2000);
                }

                if (textboxName == 'storyMessage') {
                    this.copied4 = true;
                    setTimeout(() => {
                        this.copied4 = false;
                    }, 2000);
                }


            },
            generate() {
                this.isBusy = true;
                this.results = false;
                this.shareMessage = null;

                api.getDeal(this.dealNumber).then((response) => {
                    console.log('response', response);
                    console.log('settings', settings);
                    if (response && response.data) {
                        this.dealDetails = response.data;
                        
                        if (!this.dealTitle && this.dealDetails.Title) {
                            this.dealTitle = this.dealDetails.Title;
                        }

                        let dealLink = `https://${settings.siteUrl}/Deal/${this.dealNumber}`;
                        let retailPrice = null;
                        let salePrice = null;
                        let percentOff = this.getPercentOff(this.dealDetails);
                        console.log('percentOff', percentOff);
                        if (this.dealDetails.RetailPrice) {
                            retailPrice = this.dealDetails.RetailPrice.toFixed(2);
                        }
                        if (this.dealDetails.DealPrice) {
                            salePrice = this.dealDetails.DealPrice.toFixed(2);
                        }

                        let facebook_post = `${this.dealText} Only $${salePrice}!
👉 ${dealLink}`;


                        let whatsapp_post = `*${this.dealText}*

~Was $${retailPrice}~ *NOW $${salePrice}*

${this.dealTitle}
👉 ${dealLink}

*_Share this deal with friends!_*
🤱 Link to WhatsApp group: *${settings.socialLinks.whatsapp}*`;

                        if (!retailPrice) {
                            whatsapp_post = `${this.dealText} *ONLY $${salePrice}*

${this.dealTitle}
👉 ${dealLink}

*_Share this deal with friends!_*
🤱 Link to WhatsApp group: *${settings.socialLinks.whatsapp}*`;
                        }


                        let story_post = `*${this.dealText}*

~Was $${retailPrice}~ *NOW $${salePrice}*

${this.dealTitle}
👉 ${dealLink}`;

                        if (!retailPrice) {
                            story_post = `${this.dealText} 

*ONLY $${salePrice}*

${this.dealTitle}
👉 ${dealLink}`;
                        }


                        this.shareMessage = whatsapp_post;
                        this.facebookMessage = facebook_post;
                        this.storyMessage = story_post;

                        if (percentOff) {
                            let facebook_post2 = `${this.dealText} ${percentOff}% OFF!
👉 ${dealLink}`;
                            this.facebookMessage2 = facebook_post2;
                        }
                        else
                            this.facebookMessage2 = null;

                        this.telegram.message = `${this.dealText}`;
                        this.telegram.isPosted = false;

                        this.images = this.getImages();


                    }



                }).finally(() => {
                    this.isBusy = false;
                });

            },
            getPercentOff(deal) {
                if (deal.RetailPrice && deal.DealPrice && deal.RetailPrice >= 0) {
                    var percentOff = Math.round((deal.RetailPrice - deal.DealPrice) / deal.RetailPrice * 100.00);
                    return percentOff;
                }
                else
                    return null;
            },
            postToTelegram() {
                this.telegram.isBusy = true;
                api.postToTelegram({ dealId: this.dealNumber, message: this.telegram.message }).then(response => {
                    this.telegram.isPosted = true;
                    this.telegram.isBusy = false;
                });
            },
            getImages() {
                return [
                    '/storyimage/' + this.dealNumber + '.jpg?color=pink&title=' + window.encodeURIComponent(this.dealTitle) + '&message=' + window.encodeURIComponent(this.dealText),
                    '/storyimage/' + this.dealNumber + '.jpg?color=fushia&title=' + window.encodeURIComponent(this.dealTitle) + '&message=' + window.encodeURIComponent(this.dealText),
                    '/storyimage/' + this.dealNumber + '.jpg?color=orange&title=' + window.encodeURIComponent(this.dealTitle) + '&message=' + window.encodeURIComponent(this.dealText),
                    '/storyimage/' + this.dealNumber + '.jpg?color=purple&title=' + window.encodeURIComponent(this.dealTitle) + '&message=' + window.encodeURIComponent(this.dealText),
                    '/storyimage/' + this.dealNumber + '.jpg?color=blue&title=' + window.encodeURIComponent(this.dealTitle) + '&message=' + window.encodeURIComponent(this.dealText),
                    '/storyimage/' + this.dealNumber + '.jpg?color=green&title=' + window.encodeURIComponent(this.dealTitle) + '&message=' + window.encodeURIComponent(this.dealText)
                ]
            }
        },
        created() {
            if (this.$route.query.dealNumber) {
                this.dealNumber = this.$route.query.dealNumber;
                this.generate();
            }

            this.getLatestDeals();
        },
        computed: {
            settings: function () { return settings; },
            dealDetailsJson: function () { return JSON.stringify(this.dealDetails); }
        },
        components: {
            TabMenu
        }
    }
</script>
<style>
</style>